export const PlatformType = {
    IOS: 'ios',
    ANDROID: 'android',
    WEB: 'web',
} as const;

export type PlatformTypeType = (typeof PlatformType)[keyof typeof PlatformType];

export const DeviceType = {
    IOS: 'IOS',
    ANDROID: 'ANDROID',
} as const;

export type DeviceTypeType = (typeof DeviceType)[keyof typeof DeviceType];
